
@if (task.status === 0) {
    <mat-icon class="export-icon" [svgIcon]="'heroicons_outline:document-arrow-down'"></mat-icon>
} @else if (task.status === 1) {
    <mat-icon class="export-icon" [svgIcon]="'heroicons_outline:check-circle'"></mat-icon>
} @else {
    <mat-icon class="export-icon" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
}
<div class="container">
    <div class="title">{{ task.title }}</div>
    @if (task.status === 0) {
        <progress id="file" [max]="task.iterations" [value]="task.iteration - 1"></progress>
    } @else if (task.status === 1) {
        Completado
    } @else {
        Cancelado
    }
</div>
@if (task.status === 0) {
    <button mat-icon-button (click)="onCancelButtonPressed()" matTooltip="Cancelar">
        <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
    </button>  
}
